import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Stack } from "react-bootstrap";

import { useQuery } from "../../hooks";

import QRCode from "./QRCode";
import styles from "./SignupCodePage.module.css"

export function SignupLink() {
  const { data: user } = useQuery("users/1");
  const enabled = user?.is_admin || false
  const { data } = useQuery("create_codes", "1", { retry: false, enabled });
  
  if (!data?.signup_link) return null

  return (
    <>
      <a className={styles.link} href="/admin/">Admin</a>
      <Link to="/signup_url" className={styles.link}>Signup Link</Link>
    </>
  )
}

export default function SignupCodePage() {
  const { data, isFetching } = useQuery("create_codes", "1");
  const navigate = useNavigate()
  
  useEffect(() => {
    if (!isFetching && !data?.signup_link) {
      navigate('/')
    }
  }, [navigate, isFetching, data])

  if (!data?.signup_link) return null

  const formattedDate = new Date(data.expires_at).toLocaleString()
  
  return (
    <Stack gap={3} className={styles.container}>
      <QRCode url={data.signup_link} />
      <p>Expires at: {formattedDate}</p>
    </Stack>
  )
}
